export default __webpack_public_path__ + "static/media/processes.82a90f7b.png";